import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import Shell from "@/pages/Shell";
import Dashboard from "@/pages/Dashboard";
import Bookings from "@/pages/Bookings";
import BookingNew from "@/pages/BookingNew";
import BookingEdit from "@/pages/BookingEdit";
import BookingDetail from "@/pages/BookingDetail";
import PaymentDesk from "@/pages/PaymentDesk";
import Users from "@/pages/Users";
import Merchants from "@/pages/Merchants";
import AuditLog from "@/pages/AuditLog";

function Guard({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-10 text-slate-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role) && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function Routed() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<Guard><Shell /></Guard>}>
        <Route index element={<Dashboard />} />
        <Route path="bookings" element={<Bookings />} />
        <Route path="bookings/new" element={<Guard roles={["agent"]}><BookingNew /></Guard>} />
        <Route path="bookings/:id" element={<BookingDetail />} />
        <Route path="bookings/:id/edit" element={<Guard roles={["agent"]}><BookingEdit /></Guard>} />
        <Route path="payment-desk" element={<Guard roles={["payment_team"]}><PaymentDesk /></Guard>} />
        <Route path="users" element={<Guard roles={["admin"]}><Users /></Guard>} />
        <Route path="merchants" element={<Guard roles={["admin"]}><Merchants /></Guard>} />
        <Route path="audit" element={<Guard roles={["admin"]}><AuditLog /></Guard>} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routed />
        <Toaster position="top-right" theme="dark" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}
